import React, { useState, useEffect, useRef } from 'react';
import './App.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Analytics tracking function
const trackPageView = async (page) => {
  try {
    await fetch(`${API_URL}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: page || window.location.pathname,
        referrer: document.referrer || null
      })
    });
  } catch (e) {
  if (process.env.NODE_ENV !== 'production') console.error('Analytics tracking failed:', e);
  }
};

function App() {
  const [showContactInfo, setShowContactInfo] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [ageVerified, setAgeVerified] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [galleryIndex, setGalleryIndex] = useState(0);
  const touchStartX = useRef(0);

  const galleryItems = [
    { type: 'image', src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/y2wgax7k_IMG_4276.jpeg', alt: 'Izzie Fox Gallery 10' },
    { type: 'image', src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/1gizvmmw_IMG_4277.jpeg', alt: 'Izzie Fox Gallery 11' },
    { type: 'image', src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/49jx2vnc_IMG_4275.jpeg', alt: 'Izzie Fox Gallery 12' },
    { type: 'image', src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/6os1m79m_IMG_4574.webp', alt: 'Izzie Fox Gallery 13' },
    { type: 'image', src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/qprvr16y_IMG_4571.webp', alt: 'Izzie Fox Gallery 14' },
    { type: 'image', src: 'https://customer-assets.emergentagent.com/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/54im3c55_IMG_9321.JPG', alt: 'Izzie Fox Gallery 5' },
    { type: 'image', src: 'https://customer-assets.emergentagent.com/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/3zfxnkgs_47CA5FAF-A80D-4663-9C3A-00C371786FC8.JPG', alt: 'Izzie Fox Gallery 3' },
    { type: 'video', src: 'https://customer-assets.emergentagent.com/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/j1y3x4p7_EE0B6956-2215-4AFD-92FA-ABB1455F2632.MOV' },
    { type: 'image', src: 'https://customer-assets.emergentagent.com/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/0bsz0jjn_IMG_9306.JPG', alt: 'Izzie Fox Gallery 4' },
    { type: 'image', src: 'https://customer-assets.emergentagent.com/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/cbdrsh1s_IMG_9669.JPG', alt: 'Izzie Fox Gallery 6' },
    { type: 'image', src: 'https://customer-assets.emergentagent.com/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/vsx647ei_IMG_9690.JPG', alt: 'Izzie Fox Gallery 7' },
    { type: 'image', src: 'https://customer-assets.emergentagent.com/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/0heembdy_IMG_9679.JPG', alt: 'Izzie Fox Gallery 8' },
    { type: 'image', src: 'https://customer-assets.emergentagent.com/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/byienw70_IMG_9672.JPG', alt: 'Izzie Fox Gallery 9' },
  ];

  const nextSlide = () => setGalleryIndex((prev) => (prev + 1) % galleryItems.length);
  const prevSlide = () => setGalleryIndex((prev) => (prev - 1 + galleryItems.length) % galleryItems.length);

  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (diff > 50) nextSlide();
    if (diff < -50) prevSlide();
  };

  // Check if user has already verified age in this session
  useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps -- mount-only: reads sessionStorage once on load
    const verified = sessionStorage.getItem('ageVerified');
    if (verified === 'true') {
      setAgeVerified(true);
      trackPageView(window.location.hash || 'home');
    }
  }, []);

  const handleAgeVerification = (isOver18) => {
    if (isOver18) {
      setAgeVerified(true);
      sessionStorage.setItem('ageVerified', 'true');
      // Track page view after age verification
      trackPageView('home');
    } else {
      // Redirect to Google or another safe site
      window.location.href = 'https://www.google.com';
    }
  };

  const services = [
    { title: 'Video Calls', description: 'Intimate one-on-one video sessions tailored to your desires', icon: '📹', url: '/video-calls' },
    { title: 'Phone Calls', description: 'Personal voice conversations for a more intimate connection', icon: '📞', url: '/phone-calls' },
    { title: 'Sexting', description: 'Flirty and exciting text conversations that will keep you engaged', icon: '💬', url: '/sexting' },
    { title: 'Custom Content', description: 'Personalized content created specifically for your fantasies', icon: '📸', url: '/custom-content' },
    { title: 'Content', description: 'Premade premium photos and videos', icon: '🎥', url: '/content' },
    { title: 'Cock Ratings', description: 'Honest and detailed ratings with personalized feedback', icon: '⭐', url: '/dick-ratings' },
    { title: 'Worn Items', description: 'Personal worn items for that extra special connection', icon: '👙', url: '/worn-items' },
    { title: 'Girlfriend Experience', description: 'A more personal and attentive online experience', icon: '💕', url: '/girlfriend-experience' },
  ];

  return (
    <div className="min-h-screen bg-white" onContextMenu={(e) => { if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') e.preventDefault(); }}>
      {/* Image Protection Styles */}
      <style>{`
        img, video {
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          -webkit-user-drag: none;
          -webkit-touch-callout: none;
          pointer-events: auto;
        }
        img::selection, video::selection {
          background: transparent;
        }
        .watermark-container {
          position: relative;
          overflow: hidden;
        }
        .watermark-container::after {
          content: 'Izzie Fox | izziefox.co.uk';
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          color: rgba(255, 255, 255, 0.5);
          font-size: 28px;
          font-weight: 800;
          letter-spacing: 3px;
          text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.7);
          pointer-events: none;
          z-index: 10;
          white-space: nowrap;
        }
      `}</style>
      {/* Age Verification Modal */}
      {!ageVerified && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-90 backdrop-blur-md">
          <div className="max-w-md w-full mx-4 bg-white rounded-3xl shadow-2xl p-8 text-center border-4" style={{borderColor: '#EBBEDA'}}>
            <div className="mb-6">
              <div className="text-6xl mb-4">🔞</div>
              <h2 className="text-3xl font-bold text-gray-800 mb-2">
                Age Verification
              </h2>
              <p className="text-gray-600 text-lg">
                This website contains adult content
              </p>
            </div>
            
            <div className="mb-6 text-left bg-pink-50 rounded-2xl p-4 border-2" style={{borderColor: '#EBBEDA'}}>
              <p className="text-gray-700 text-sm leading-relaxed">
                You must be <span className="font-bold">18 years or older</span> to enter this website. 
                By clicking "Enter", you confirm that you are of legal age to view adult content in your jurisdiction.
              </p>
            </div>

            <div className="space-y-3">
              <button
                onClick={() => handleAgeVerification(true)}
                className="w-full px-8 py-4 text-white rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-lg"
                style={{background: '#EBBEDA'}}
                onMouseOver={(e) => e.target.style.background = '#D9A8C9'}
                onMouseOut={(e) => e.target.style.background = '#EBBEDA'}
                data-testid="age-verify-enter"
              >
                ✓ Yes, I'm 18 or Older - Enter
              </button>
              
              <button
                onClick={() => handleAgeVerification(false)}
                className="w-full px-8 py-4 bg-gray-200 text-gray-700 rounded-full font-semibold text-lg transition-all hover:bg-gray-300"
                data-testid="age-verify-exit"
              >
                ✗ No, I'm Under 18 - Exit
              </button>
            </div>

            <p className="text-gray-500 text-xs mt-6">
              By entering, you agree that you are of legal age and accept our <button onClick={() => setShowTerms(true)} className="underline font-semibold" style={{color: '#EBBEDA'}}>Terms of Service</button>.
            </p>
          </div>
        </div>
      )}

      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white bg-opacity-95 backdrop-blur-sm z-50 shadow-sm" style={{borderBottom: '1px solid #EBBEDA'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="text-2xl font-bold" style={{color: '#EBBEDA'}}>
              Izzie <span style={{color: '#EBBEDA'}}>Fox</span>
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-8">
              <a href="#home" className="text-gray-700 transition-colors font-medium" onMouseOver={(e) => e.target.style.color = '#EBBEDA'} onMouseOut={(e) => e.target.style.color = ''}>Home</a>
              <a href="#services" className="text-gray-700 transition-colors font-medium" onMouseOver={(e) => e.target.style.color = '#EBBEDA'} onMouseOut={(e) => e.target.style.color = ''}>Services</a>
              <a href="#about" className="text-gray-700 transition-colors font-medium" onMouseOver={(e) => e.target.style.color = '#EBBEDA'} onMouseOut={(e) => e.target.style.color = ''}>About Me</a>
              <a href="/verify" className="text-gray-700 transition-colors font-medium" onMouseOver={(e) => e.target.style.color = '#EBBEDA'} onMouseOut={(e) => e.target.style.color = ''}>Verification</a>
              <a href="#gallery" className="text-gray-700 transition-colors font-medium" onMouseOver={(e) => e.target.style.color = '#EBBEDA'} onMouseOut={(e) => e.target.style.color = ''}>Gallery</a>
              <a href="https://onlyfans.com/izziefox1" target="_blank" rel="noopener noreferrer" className="text-gray-700 transition-colors font-medium" onMouseOver={(e) => e.target.style.color = '#EBBEDA'} onMouseOut={(e) => e.target.style.color = ''}>OnlyFans</a>
              <a href="#contact" className="text-gray-700 transition-colors font-medium" onMouseOver={(e) => e.target.style.color = '#EBBEDA'} onMouseOut={(e) => e.target.style.color = ''}>Connect</a>
              <a href="#wishlist" className="text-gray-700 transition-colors font-medium" onMouseOver={(e) => e.target.style.color = '#EBBEDA'} onMouseOut={(e) => e.target.style.color = ''}>Spoil Me</a>
              <a href="#payments" className="text-gray-700 transition-colors font-medium" onMouseOver={(e) => e.target.style.color = '#EBBEDA'} onMouseOut={(e) => e.target.style.color = ''}>Payment Methods</a>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden p-2 rounded-lg transition-colors"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              style={{color: '#EBBEDA'}}
              aria-label="Toggle menu"
            >
              <svg className="w-6 h-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                {mobileMenuOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden pb-4 pt-2 border-t" style={{borderColor: '#EBBEDA'}}>
              <div className="flex flex-col space-y-3">
                <a 
                  href="#home" 
                  className="text-gray-700 hover:bg-pink-50 px-4 py-2 rounded-lg transition-colors font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                  style={{color: '#4B5563'}}
                  onMouseOver={(e) => e.target.style.color = '#EBBEDA'}
                  onMouseOut={(e) => e.target.style.color = '#4B5563'}
                >
                  Home
                </a>
                <a 
                  href="#services" 
                  className="text-gray-700 hover:bg-pink-50 px-4 py-2 rounded-lg transition-colors font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                  style={{color: '#4B5563'}}
                  onMouseOver={(e) => e.target.style.color = '#EBBEDA'}
                  onMouseOut={(e) => e.target.style.color = '#4B5563'}
                >
                  Services
                </a>
                <a 
                  href="#about" 
                  className="text-gray-700 hover:bg-pink-50 px-4 py-2 rounded-lg transition-colors font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                  style={{color: '#4B5563'}}
                  onMouseOver={(e) => e.target.style.color = '#EBBEDA'}
                  onMouseOut={(e) => e.target.style.color = '#4B5563'}
                >
                  About Me
                </a>
                <a 
                  href="/verify" 
                  className="text-gray-700 hover:bg-pink-50 px-4 py-2 rounded-lg transition-colors font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                  style={{color: '#4B5563'}}
                  onMouseOver={(e) => e.target.style.color = '#EBBEDA'}
                  onMouseOut={(e) => e.target.style.color = '#4B5563'}
                >
                  Verification
                </a>
                <a 
                  href="#gallery" 
                  className="text-gray-700 hover:bg-pink-50 px-4 py-2 rounded-lg transition-colors font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                  style={{color: '#4B5563'}}
                  onMouseOver={(e) => e.target.style.color = '#EBBEDA'}
                  onMouseOut={(e) => e.target.style.color = '#4B5563'}
                >
                  Gallery
                </a>
                <a 
                  href="https://onlyfans.com/izziefox1" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:bg-pink-50 px-4 py-2 rounded-lg transition-colors font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                  style={{color: '#4B5563'}}
                  onMouseOver={(e) => e.target.style.color = '#EBBEDA'}
                  onMouseOut={(e) => e.target.style.color = '#4B5563'}
                >
                  OnlyFans
                </a>
                <a 
                  href="#contact" 
                  className="text-gray-700 hover:bg-pink-50 px-4 py-2 rounded-lg transition-colors font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                  style={{color: '#4B5563'}}
                  onMouseOver={(e) => e.target.style.color = '#EBBEDA'}
                  onMouseOut={(e) => e.target.style.color = '#4B5563'}
                >
                  Connect
                </a>
                <a 
                  href="#wishlist" 
                  className="text-gray-700 hover:bg-pink-50 px-4 py-2 rounded-lg transition-colors font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                  style={{color: '#4B5563'}}
                  onMouseOver={(e) => e.target.style.color = '#EBBEDA'}
                  onMouseOut={(e) => e.target.style.color = '#4B5563'}
                >
                  Spoil Me
                </a>
                <a 
                  href="#payments" 
                  className="text-gray-700 hover:bg-pink-50 px-4 py-2 rounded-lg transition-colors font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                  style={{color: '#4B5563'}}
                  onMouseOver={(e) => e.target.style.color = '#EBBEDA'}
                  onMouseOut={(e) => e.target.style.color = '#4B5563'}
                >
                  Payment Methods
                </a>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-repeat-x bg-center"
          style={{
            backgroundImage: 'url(https://customer-assets-cm19k8pv.emergentagent.net/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/sqrznl2e_IMG_4754.webp)',
            backgroundPosition: 'center top',
            backgroundSize: 'contain'
          }}
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0" style={{background: 'linear-gradient(135deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.5) 100%)'}} />
        
        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-8xl font-bold text-white mb-6 drop-shadow-2xl">
            Izzie <span style={{color: '#EBBEDA'}}>Fox</span>
          </h1>
          <p className="text-xl md:text-2xl text-white mb-8 font-light drop-shadow-lg">
            Independent UK Adult Content Creator
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#services" 
              className="px-8 py-4 bg-white rounded-full font-semibold transition-all transform hover:scale-105 border-2 shadow-lg"
              style={{color: '#EBBEDA', borderColor: '#EBBEDA'}}
              onMouseOver={(e) => e.target.style.background = '#FAF8FB'}
              onMouseOut={(e) => e.target.style.background = 'white'}
            >
              Explore Services
            </a>
            <a 
              href="#gallery" 
              className="px-8 py-4 bg-white rounded-full font-semibold transition-all transform hover:scale-105 border-2 shadow-lg"
              style={{color: '#EBBEDA', borderColor: '#EBBEDA'}}
              onMouseOver={(e) => e.target.style.background = '#FAF8FB'}
              onMouseOut={(e) => e.target.style.background = 'white'}
              data-testid="hero-gallery-btn"
            >
              Gallery
            </a>
            <a 
              href="/verify" 
              className="px-8 py-4 bg-white rounded-full font-semibold transition-all transform hover:scale-105 border-2 shadow-lg"
              style={{color: '#EBBEDA', borderColor: '#EBBEDA'}}
              onMouseOver={(e) => e.target.style.background = '#FAF8FB'}
              onMouseOut={(e) => e.target.style.background = 'white'}
              data-testid="hero-verification-btn"
            >
              Verification
            </a>
            <a 
              href="#contact" 
              className="px-8 py-4 bg-white rounded-full font-semibold transition-all transform hover:scale-105 border-2 shadow-lg"
              style={{color: '#EBBEDA', borderColor: '#EBBEDA'}}
              onMouseOver={(e) => e.target.style.background = '#FAF8FB'}
              onMouseOut={(e) => e.target.style.background = 'white'}
            >
              Get in Touch
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              My <span style={{color: '#EBBEDA'}}>Services</span>
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Private video calls, sexting, custom adult content and more from an independent UK creator
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service) => (
              <a 
                href={service.url}
                key={service.title}
                className="group rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 transform hover:-translate-y-2 block"
                style={{
                  background: 'linear-gradient(135deg, #FAF8FB 0%, #FFFFFF 100%)',
                  borderColor: '#EBBEDA'
                }}
                onMouseOver={(e) => e.currentTarget.style.borderColor = '#D9A8C9'}
                onMouseOut={(e) => e.currentTarget.style.borderColor = '#EBBEDA'}
                data-testid={`service-card-${service.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">
                  {service.icon}
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
                <span className="text-sm font-semibold mt-3 inline-block" style={{color: '#EBBEDA'}}>Learn more →</span>
              </a>
            ))}
          </div>
          <div className="text-center mt-10">
            <a href="/services" className="inline-block px-8 py-3 rounded-full font-semibold border-2 transition-all hover:scale-105" style={{color: '#EBBEDA', borderColor: '#EBBEDA'}} data-testid="view-all-services">
              View All Services →
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20" style={{background: 'linear-gradient(135deg, #F5F0F6 0%, #FAF8FB 50%, #FFFFFF 100%)'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-800">
                About <span style={{color: '#EBBEDA'}}>Me</span>
              </h2>
              <div className="space-y-4 text-gray-700 text-lg leading-relaxed">
                <p className="font-semibold">
                  Hey! I'm Izzie Fox, a UK based online content creator, and I'm so glad you found me!
                </p>
                <p>
                  I'm an <span className="font-semibold">ONLINE-ONLY</span> adult content creator who's offering a safe, kink-friendly space where connection, fantasy and fun come together. Whether you're into playful chats, steamy video calls, custom content, or just need someone who truly gets your vibe - I'm here for it.
                </p>
                <p>
                  I specialise in a range of virtual services including phone calls, sexting sessions, fetish friendly experiences, worn item sales, and custom videos tailored to your desires. Every interaction is built on consent, comfort and a no-judgment zone where you can relax and be yourself.
                </p>
                <p>
                  If you're looking for someone who's open-minded, down-to-earth, and always online, you've come to the right place.
                </p>
                <p className="font-semibold" style={{color: '#EBBEDA'}}>
                  Let's have a little fun - your secret's safe with me.
                </p>
              </div>
            </div>
            <div className="order-1 md:order-2 watermark-container rounded-2xl">
              <img 
                src="https://customer-assets-cm19k8pv.emergentagent.net/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/asydcb6b_IMG_4275.jpeg" 
                alt="Izzie Fox - Independent UK Adult Content Creator and Webcam Model"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover border-4"
                style={{borderColor: '#EBBEDA'}}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Verification Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-gradient-to-r from-pink-50 to-white rounded-3xl p-8 md:p-12 shadow-lg border-2" style={{borderColor: '#EBBEDA'}}>
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-6" style={{background: '#EBBEDA'}}>
              <span className="text-3xl">✓</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Want Proof I'm <span style={{color: '#EBBEDA'}}>Real</span>?
            </h2>
            <p className="text-gray-600 text-lg mb-6 max-w-xl mx-auto">
              Watch my verification video to see that you're connecting with the real me.
            </p>
            <a 
              href="/verify"
              className="inline-flex items-center gap-2 px-8 py-4 text-white font-bold text-lg rounded-full transition-all hover:scale-105 cursor-pointer"
              style={{background: 'linear-gradient(135deg, #EBBEDA 0%, #D9A8C9 100%)', boxShadow: '0 4px 0 #C48FB5, 0 6px 15px rgba(235, 190, 218, 0.4)'}}
              onMouseDown={(e) => { e.target.style.transform = 'translateY(2px)'; e.target.style.boxShadow = '0 2px 0 #C48FB5, 0 3px 8px rgba(235, 190, 218, 0.4)'; }}
              onMouseUp={(e) => { e.target.style.transform = ''; e.target.style.boxShadow = '0 4px 0 #C48FB5, 0 6px 15px rgba(235, 190, 218, 0.4)'; }}
              onMouseLeave={(e) => { e.target.style.transform = ''; e.target.style.boxShadow = '0 4px 0 #C48FB5, 0 6px 15px rgba(235, 190, 218, 0.4)'; }}
              data-testid="verification-link"
            >
              ✓ View Verification Video
            </a>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              <span style={{color: '#EBBEDA'}}>Gallery</span>
            </h2>
            <p className="text-gray-600 text-lg">
              A glimpse into my world
            </p>
          </div>
          <div 
            className="relative"
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            data-testid="gallery-carousel"
          >
            {/* Main slide */}
            <div className="watermark-container relative overflow-hidden rounded-2xl shadow-xl border-4 flex items-center justify-center" style={{borderColor: '#EBBEDA', minHeight: '80vh', background: '#f9f5f7'}}>
              {galleryItems[galleryIndex].type === 'video' ? (
                <video 
                  src={galleryItems[galleryIndex].src}
                  className="max-w-full max-h-[85vh] object-contain"
                  controls
                  playsInline
                  muted
                />
              ) : (
                <img 
                  src={galleryItems[galleryIndex].src}
                  alt={galleryItems[galleryIndex].alt}
                  className="max-w-full max-h-[85vh] object-contain transition-opacity duration-300"
                />
              )}
            </div>

            {/* Prev/Next buttons */}
            <button 
              onClick={prevSlide}
              className="absolute left-3 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center transition-all hover:scale-110"
              style={{color: '#EBBEDA'}}
              data-testid="gallery-prev"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
            </button>
            <button 
              onClick={nextSlide}
              className="absolute right-3 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center transition-all hover:scale-110"
              style={{color: '#EBBEDA'}}
              data-testid="gallery-next"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
            </button>

            {/* Dots */}
            <div className="flex justify-center gap-2 mt-6">
              {galleryItems.map((item, i) => (
                <button 
                  key={item.src}
                  onClick={() => setGalleryIndex(i)}
                  className="w-3 h-3 rounded-full transition-all"
                  style={{background: i === galleryIndex ? '#EBBEDA' : '#E5E7EB', transform: i === galleryIndex ? 'scale(1.3)' : 'scale(1)'}}
                />
              ))}
            </div>
            <p className="text-center text-gray-400 text-sm mt-3">{galleryIndex + 1} / {galleryItems.length}</p>
          </div>
        </div>
      </section>

      {/* Free OnlyFans Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-gradient-to-r from-pink-50 to-white rounded-3xl p-8 md:p-12 shadow-lg border-2" style={{borderColor: '#EBBEDA'}}>
            <div className="inline-flex items-center gap-2 px-6 py-2 rounded-full mb-6 text-base font-bold tracking-widest" style={{background: '#00AFF0', color: '#fff', boxShadow: '0 0 20px rgba(0, 175, 240, 0.5)'}}>
              100% FREE
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{color: '#EBBEDA'}}>
              Just a cheeky blonde causing a little <span style={{color: '#00AFF0'}}>chaos</span>
            </h2>
            <p className="text-gray-600 text-lg mb-6 max-w-xl mx-auto">
              You've seen enough to be curious... my FREE OnlyFans is where things get more interesting.
            </p>
            <a 
              href="https://onlyfans.com/izziefox1"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 text-white font-bold text-lg rounded-full transition-all hover:scale-105 cursor-pointer"
              style={{background: 'linear-gradient(135deg, #00AFF0 0%, #0090C8 100%)', boxShadow: '0 4px 0 #0078A8, 0 6px 15px rgba(0, 175, 240, 0.4)'}}
              onMouseDown={(e) => { e.target.style.transform = 'translateY(2px)'; e.target.style.boxShadow = '0 2px 0 #0078A8, 0 3px 8px rgba(0, 175, 240, 0.4)'; }}
              onMouseUp={(e) => { e.target.style.transform = ''; e.target.style.boxShadow = '0 4px 0 #0078A8, 0 6px 15px rgba(0, 175, 240, 0.4)'; }}
              onMouseLeave={(e) => { e.target.style.transform = ''; e.target.style.boxShadow = '0 4px 0 #0078A8, 0 6px 15px rgba(0, 175, 240, 0.4)'; }}
              data-testid="free-onlyfans-link"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 17.07c-1.465 1.375-3.455 2.18-5.596 2.18-2.22 0-4.17-.734-5.636-2.18C5.197 15.696 4.5 13.934 4.5 12c0-1.934.697-3.696 2.162-5.07C8.128 5.555 10.078 4.75 12.298 4.75c2.14 0 4.13.805 5.596 2.18C19.36 8.304 20 10.066 20 12c0 1.934-.64 3.696-2.106 5.07zM12 7.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/></svg>
              Enter My Free OnlyFans
            </a>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20" style={{background: 'linear-gradient(135deg, #FAF8FB 0%, #FFFFFF 50%, #F5F0F6 100%)'}}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-800">
            Let's <span style={{color: '#EBBEDA'}}>Connect</span>
          </h2>
          <p className="text-gray-600 text-lg mb-12 max-w-2xl mx-auto">
            Ready to start an unforgettable experience? Reach out to me through WhatsApp or social media.
          </p>
          
          <div className="space-y-6">
            {/* WhatsApp Button - To be updated */}
            <div className="bg-white rounded-2xl p-8 border-2 shadow-lg" style={{borderColor: '#EBBEDA'}}>
              <div className="flex items-center justify-center gap-4 mb-4">
                <svg className="w-12 h-12 text-green-500" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                <div className="text-left">
                  <h3 className="text-2xl font-bold text-gray-800">WhatsApp</h3>
                  <p className="text-gray-500 text-sm">Let's chat directly!</p>
                </div>
              </div>
              <a 
                href="https://wa.me/447386375420"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-3 bg-green-600 text-white rounded-full font-semibold hover:bg-green-700 transition-all transform hover:scale-105"
                data-testid="whatsapp-button"
              >
                💬 WhatsApp Me
              </a>
            </div>

            {/* Telegram Button */}
            <div className="bg-white rounded-2xl p-8 border-2 shadow-lg" style={{borderColor: '#EBBEDA'}}>
              <div className="flex items-center justify-center gap-4 mb-4">
                <svg className="w-12 h-12" style={{color: '#0088cc'}} fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
                <div className="text-left">
                  <h3 className="text-2xl font-bold text-gray-800">Telegram</h3>
                  <p className="text-gray-500 text-sm">Message me on Telegram!</p>
                </div>
              </div>
              <a 
                href="https://t.me/izziefoxx"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-3 text-white rounded-full font-semibold transition-all transform hover:scale-105"
                style={{background: '#0088cc'}}
                data-testid="telegram-button"
              >
                ✈ @izziefoxx
              </a>
            </div>

            {/* Telegram Channel */}
            <div className="bg-white rounded-2xl p-8 border-2 shadow-lg" style={{borderColor: '#EBBEDA'}}>
              <div className="flex items-center justify-center gap-4 mb-4">
                <svg className="w-12 h-12" style={{color: '#0088cc'}} fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
                <div className="text-left">
                  <h3 className="text-2xl font-bold text-gray-800">Telegram Channel</h3>
                  <p className="text-gray-500 text-sm">Join my Telegram channel for updates!</p>
                </div>
              </div>
              <a 
                href="https://t.me/izzieefox"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-3 text-white rounded-full font-semibold transition-all transform hover:scale-105"
                style={{background: '#0088cc'}}
                data-testid="telegram-channel-button"
              >
                Join Channel
              </a>
            </div>

            {/* Social Media Links */}
            <div className="bg-white rounded-2xl p-8 border-2 shadow-lg" style={{borderColor: '#EBBEDA'}}>
              <h3 className="text-2xl font-bold mb-6 text-gray-800">Follow Me</h3>
              <div className="flex justify-center gap-6">
                <a 
                  href="https://www.instagram.com/izzieefoxx/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 rounded-full flex items-center justify-center transition-transform hover:scale-110"
                  style={{background: 'linear-gradient(135deg, #C084FC 0%, #EBBEDA 100%)'}}
                  title="Follow me on Instagram"
                >
                  <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a 
                  href="https://x.com/izzieefox"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 rounded-full flex items-center justify-center transition-transform hover:scale-110"
                  style={{background: '#000000'}}
                  title="Follow me on X"
                >
                  <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
                <a 
                  href="https://t.me/izziefoxx"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 rounded-full flex items-center justify-center transition-transform hover:scale-110"
                  style={{background: '#60A5FA'}}
                  title="Message me on Telegram"
                >
                  <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                  </svg>
                </a>
              </div>
              <p className="text-gray-600 text-sm mt-6">Connect with me on your favorite platform!</p>
            </div>
          </div>
        </div>
      </section>

      {/* Wishlist Section */}
      <section id="wishlist" className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-8">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              ✨ <span style={{color: '#EBBEDA'}}>Spoil Me</span> ✨
            </h2>
          </div>
          
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl border-2" style={{borderColor: '#EBBEDA'}}>
            <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-8">
              Love what you see? Want to make me smile? Check out my wishlist and treat me to something special. 
              Every gift is appreciated and gets you <span className="font-semibold" style={{color: '#EBBEDA'}}>extra attention</span> 💕
            </p>
            
            <div className="flex justify-center">
              <a 
                href="https://throne.com/izzieefoxx"
                target="_blank"
                rel="noopener noreferrer"
                className="px-10 py-4 text-white rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-lg inline-block"
                style={{background: '#EBBEDA'}}
                data-testid="wishlist-button"
              >
                🎁 View My Wishlist
              </a>
            </div>
            
            <p className="text-gray-500 text-sm mt-6">
              Every gift makes my day brighter! 💕
            </p>
          </div>
        </div>
      </section>

      {/* Payment Methods Section */}
      <section id="payments" className="py-20" style={{background: 'linear-gradient(135deg, #FAF8FB 0%, #FFFFFF 50%, #F5F0F6 100%)'}}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-800">
            Payment <span style={{color: '#EBBEDA'}}>Methods</span>
          </h2>
          <p className="text-gray-600 text-lg mb-12 max-w-2xl mx-auto">
            Flexible and discreet payment options for your convenience
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all" style={{borderTop: '4px solid #EBBEDA'}}>
              <div className="text-4xl mb-4">🏦</div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Bank Transfer</h3>
              <p className="text-gray-600 text-sm">Direct and secure bank transfers</p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all" style={{borderTop: '4px solid #EBBEDA'}}>
              <div className="text-4xl mb-4">🔗</div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Payment Link</h3>
              <p className="text-gray-600 text-sm">Pay by credit or debit card via a payment link I send you — completely discreet</p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all" style={{borderTop: '4px solid #EBBEDA'}}>
              <div className="text-4xl mb-4">💳</div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Revolut</h3>
              <p className="text-gray-600 text-sm">Fast and easy payments via Revolut</p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all" style={{borderTop: '4px solid #EBBEDA'}}>
              <div className="text-4xl mb-4">🎁</div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Gift Cards</h3>
              <p className="text-gray-600 text-sm">Prezzy or Amazon gift cards</p>
              <p className="text-xs mt-2 font-semibold" style={{color: '#EBBEDA'}}>+£5-10 fee applies</p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all" style={{borderTop: '4px solid #EBBEDA'}}>
              <div className="text-4xl mb-4">₿</div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Crypto</h3>
              <p className="text-gray-600 text-sm">Bitcoin and other cryptocurrencies accepted</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t-2 py-8" style={{borderColor: '#FFD1DC'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-gray-600">
          <p className="text-lg mb-2">
            <span className="text-gray-800 font-bold">Izzie <span style={{color: '#EBBEDA'}}>Fox</span></span>
          </p>
          <p className="text-sm mb-3">© 2026 Izzie Fox. All rights reserved. | 18+ Content | Discretion Assured</p>
          <div className="flex justify-center gap-4 text-sm mb-3">
            <a href="/services" className="hover:underline" style={{color: '#EBBEDA'}}>Services</a>
            <span>|</span>
            <a href="https://linktr.ee/IzzieFox" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{color: '#EBBEDA'}}>Linktree</a>
            <span>|</span>
            <button 
              onClick={() => setShowTerms(true)}
              className="hover:underline"
              style={{color: '#EBBEDA'}}
            >
              Terms of Service
            </button>
            <span>|</span>
            <button 
              onClick={() => setShowPrivacy(true)}
              className="hover:underline"
              style={{color: '#EBBEDA'}}
            >
              Privacy Policy
            </button>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/447386375420"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-5 py-3 bg-green-500 text-white font-bold rounded-full shadow-lg transition-all hover:scale-110 hover:bg-green-600"
        style={{boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)'}}
        data-testid="floating-whatsapp-btn"
      >
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
        Message Me
      </a>

      {/* Terms of Service Modal */}
      {showTerms && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-90 backdrop-blur-md overflow-y-auto p-4">
          <div className="max-w-4xl w-full bg-white rounded-3xl shadow-2xl my-8 border-4" style={{borderColor: '#EBBEDA'}}>
            <div className="sticky top-0 bg-white rounded-t-3xl border-b-2 p-6 flex justify-between items-center" style={{borderColor: '#EBBEDA'}}>
              <h2 className="text-3xl font-bold text-gray-800">
                Terms of Service
              </h2>
              <button 
                onClick={() => setShowTerms(false)}
                className="text-gray-500 hover:text-gray-700 text-3xl font-bold"
              >
                ×
              </button>
            </div>
            
            <div className="p-8 overflow-y-auto max-h-[70vh] text-left">
              <div className="space-y-6 text-gray-700">
                <div>
                  <p className="text-sm text-gray-500 mb-4">Last Updated: January 2025</p>
                  <p className="mb-4">
                    Welcome to Izzie Fox's website. By accessing or using this website, you agree to be bound by these Terms of Service. 
                    If you do not agree to these terms, please exit immediately.
                  </p>
                  <p className="mb-4 font-semibold">
                    These Terms of Service apply to all platforms and channels operated by Izzie Fox, including but not limited to: 
                    this website, WhatsApp, Instagram, X (Twitter), Telegram, OnlyFans, and any other social media or communication 
                    channels used to advertise or provide services under the name Izzie Fox.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>1. Age Verification & Adult Content</h3>
                  <p className="mb-2">This website and all associated services contain adult content. By using this website, you confirm that:</p>
                  <ul className="list-disc ml-6 space-y-1">
                    <li>You are at least <span className="font-bold">18 years of age</span> to access this website</li>
                    <li>You understand this site contains adult material</li>
                    <li>Viewing adult content is legal in your location</li>
                  </ul>
                  <p className="mt-2 mb-2 font-semibold">
                    To purchase any service, customers must be at least 20 years of age. All customers will be asked to 
                    confirm their age and date of birth via WhatsApp, Telegram, or social media before any service is provided. 
                    This is a personal preference and non-negotiable. Services will not be sold to anyone under 20. 
                    Providing false age information is a serious offence and will be reported to the relevant authorities.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>2. Copyright & Intellectual Property</h3>
                  <p className="mb-2 font-semibold">ALL CONTENT IS PROTECTED BY COPYRIGHT LAW.</p>
                  <p className="mb-2">All content on this website, including but not limited to:</p>
                  <ul className="list-disc ml-6 space-y-1 mb-3">
                    <li>Photographs, images, and videos</li>
                    <li>Written content and text</li>
                    <li>Graphics, logos, and branding</li>
                    <li>Audio and multimedia content</li>
                  </ul>
                  <p className="mb-2">
                    is the exclusive property of <span className="font-bold">Izzie Fox</span> and is protected by international copyright laws. 
                    This content may NOT be reproduced, distributed, transmitted, displayed, published, or broadcast without prior written permission.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>3. Prohibited Activities</h3>
                  <p className="mb-2">You are expressly PROHIBITED from:</p>
                  <ul className="list-disc ml-6 space-y-1">
                    <li><span className="font-semibold">Copying, downloading, or saving</span> any content from this website</li>
                    <li><span className="font-semibold">Sharing, distributing, or reposting</span> content on any platform or medium</li>
                    <li><span className="font-semibold">Screen recording or capturing</span> content in any format</li>
                    <li><span className="font-semibold">Creating derivative works</span> from any content</li>
                    <li><span className="font-semibold">Using content for commercial purposes</span> without written authorization</li>
                    <li><span className="font-semibold">Impersonating or misrepresenting</span> affiliation with Izzie Fox</li>
                    <li><span className="font-semibold">Harassment, stalking, or threatening behavior</span> of any kind</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>4. DMCA & Copyright Enforcement</h3>
                  <p className="mb-2">
                    Izzie Fox takes copyright infringement seriously. Unauthorized use of content will result in:
                  </p>
                  <ul className="list-disc ml-6 space-y-1">
                    <li>Immediate DMCA takedown notices</li>
                    <li>Legal action and pursuit of damages</li>
                    <li>Reporting to relevant platforms and authorities</li>
                    <li>Permanent ban from accessing this website</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>5. Content Usage Rights</h3>
                  <p className="mb-2">
                    <span className="font-semibold">You do NOT have permission to:</span>
                  </p>
                  <ul className="list-disc ml-6 space-y-1 mb-3">
                    <li>Use content for ANY purpose outside of personal viewing on this website</li>
                    <li>Share content via social media, messaging apps, or any other platform</li>
                    <li>Store or archive content on any device or cloud service</li>
                    <li>Create compilations or collections using this content</li>
                  </ul>
                  <p>Content is licensed for <span className="font-semibold">viewing only</span> on this website during your visit.</p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>6. Privacy & Discretion</h3>
                  <p className="mb-2">
                    Your privacy is important. All interactions are confidential. You agree to:
                  </p>
                  <ul className="list-disc ml-6 space-y-1">
                    <li>Maintain discretion about your use of this website</li>
                    <li>Not disclose private communications or content</li>
                    <li>Respect the privacy and safety of Izzie Fox</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>7. No Harassment or Abuse</h3>
                  <p className="mb-2">
                    Any form of harassment, stalking, threatening behavior, or abuse will result in immediate blocking, 
                    reporting to authorities, and potential legal action.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>8. Disclaimer of Warranties</h3>
                  <p className="mb-2">
                    This website and its content are provided "as is" without warranties of any kind. 
                    Izzie Fox makes no guarantees regarding availability, accuracy, or fitness for any particular purpose.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>9. Limitation of Liability</h3>
                  <p className="mb-2">
                    Izzie Fox shall not be liable for any damages arising from the use or inability to use this website, 
                    including indirect, incidental, or consequential damages.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>10. Termination</h3>
                  <p className="mb-2">
                    Izzie Fox reserves the right to terminate or restrict access to this website at any time, 
                    for any reason, without notice.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>11. Changes to Terms</h3>
                  <p className="mb-2">
                    These Terms of Service may be updated at any time. Continued use of the website constitutes 
                    acceptance of revised terms.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>12. Governing Law</h3>
                  <p className="mb-2">
                    These terms are governed by applicable international and local laws regarding adult content, 
                    copyright, and digital media.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>13. Chargebacks & Disputes</h3>
                  <p className="mb-2">
                    Proof of service completion is retained for all transactions. Any fraudulent or false chargebacks 
                    will be reported to the relevant authorities and will result in legal action, including but not 
                    limited to proceedings through small claims court.
                  </p>
                  <p className="mb-2">
                    By purchasing any service, you acknowledge and agree that all sales are final once the service 
                    has been delivered. Filing a false chargeback constitutes fraud and will be pursued accordingly.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>14. No Refund Policy</h3>
                  <p className="mb-2">
                    All sales are final. Once a service has been booked, confirmed, and delivered, no refunds will be issued. 
                    This applies to all services including but not limited to: video calls, phone calls, sexting sessions, 
                    custom content, and any other digital services provided.
                  </p>
                  <p className="mb-2">
                    By purchasing any service, you accept and agree to this no-refund policy in full.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>15. Recording & Screenshot Prohibition</h3>
                  <p className="mb-2">
                    Recording, screenshotting, screen capturing, or redistributing any content from video calls, phone calls, 
                    sexting sessions, or custom content is strictly prohibited and illegal.
                  </p>
                  <p className="mb-2">
                    Any breach of this clause will result in immediate legal action, including reporting to law enforcement 
                    and pursuing damages through the courts. All sessions may be monitored for compliance.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>16. Content Ownership & Licensing</h3>
                  <p className="mb-2">
                    All custom content created by Izzie Fox remains the exclusive intellectual property of Izzie Fox. 
                    Buyers receive a personal, non-transferable viewing license only. This does not constitute ownership 
                    of the content.
                  </p>
                  <p className="mb-2">
                    You may not share, sell, upload, distribute, or use purchased content for any purpose other than 
                    personal viewing. Violation of this clause will result in legal action.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>17. Right to Refuse Service</h3>
                  <p className="mb-2">
                    Izzie Fox reserves the right to decline, cancel, or end any session or service at her sole discretion, 
                    without refund, if a customer is:
                  </p>
                  <ul className="list-disc ml-6 space-y-1 mb-2">
                    <li>Abusive, disrespectful, or threatening</li>
                    <li>Violating stated boundaries</li>
                    <li>Suspected of being underage</li>
                    <li>Engaging in behaviour deemed inappropriate or unsafe</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>18. Communication Boundaries & Harassment</h3>
                  <p className="mb-2">
                    Harassment, repeated unwanted contact, threatening behaviour, stalking, or sharing of private 
                    conversations will not be tolerated and will be immediately reported to the police.
                  </p>
                  <p className="mb-2">
                    All communications may be retained as evidence. Legal action will be taken against any individual 
                    who engages in harassment or intimidation across any platform.
                  </p>
                </div>

                <div className="mt-8 p-6 rounded-2xl border-2" style={{borderColor: '#EBBEDA', background: '#FFF5F7'}}>
                  <p className="font-bold mb-2">⚠️ IMPORTANT NOTICE</p>
                  <p className="text-sm">
                    By using this website, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service. 
                    Violation of these terms may result in legal action and criminal penalties under applicable copyright and cybercrime laws.
                  </p>
                </div>

                <div className="text-center mt-8">
                  <p className="font-bold mb-2">Contact for Permissions or Copyright Issues:</p>
                  <a 
                    href="https://wa.me/447386375420"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block px-6 py-2 rounded-full font-semibold"
                    style={{background: '#EBBEDA', color: 'white'}}
                  >
                    Contact via WhatsApp
                  </a>
                </div>
              </div>
            </div>

            <div className="sticky bottom-0 bg-white rounded-b-3xl border-t-2 p-6 text-center" style={{borderColor: '#EBBEDA'}}>
              <button 
                onClick={() => setShowTerms(false)}
                className="px-8 py-3 rounded-full font-bold text-white"
                style={{background: '#EBBEDA'}}
              >
                I Understand & Accept
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Privacy Policy Modal */}
      {showPrivacy && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-90 backdrop-blur-md overflow-y-auto p-4">
          <div className="max-w-4xl w-full bg-white rounded-3xl shadow-2xl my-8 border-4" style={{borderColor: '#EBBEDA'}}>
            <div className="sticky top-0 bg-white rounded-t-3xl border-b-2 p-6 flex justify-between items-center" style={{borderColor: '#EBBEDA'}}>
              <h2 className="text-3xl font-bold text-gray-800">
                Privacy Policy
              </h2>
              <button 
                onClick={() => setShowPrivacy(false)}
                className="text-gray-500 hover:text-gray-700 text-3xl font-bold"
              >
                ×
              </button>
            </div>
            
            <div className="p-8 overflow-y-auto max-h-[70vh] text-left">
              <div className="space-y-6 text-gray-700">
                <div>
                  <p className="text-sm text-gray-500 mb-4">Last Updated: January 2025</p>
                  <p className="mb-4">
                    At Izzie Fox, your privacy and discretion are of utmost importance. This Privacy Policy explains how we collect, 
                    use, and protect your information when you visit our website.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>1. Information We Collect</h3>
                  <p className="mb-2 font-semibold">We may collect the following types of information:</p>
                  
                  <p className="font-semibold mt-3 mb-1">a) Automatically Collected Information:</p>
                  <ul className="list-disc ml-6 space-y-1 mb-3">
                    <li>Browser type and version</li>
                    <li>Device information (type, operating system)</li>
                    <li>IP address and general location data</li>
                    <li>Pages visited and time spent on site</li>
                    <li>Referring website or source</li>
                    <li>Session information and cookies</li>
                  </ul>

                  <p className="font-semibold mt-3 mb-1">b) Information You Provide:</p>
                  <ul className="list-disc ml-6 space-y-1">
                    <li>Contact information (if you reach out via WhatsApp, social media, etc.)</li>
                    <li>Messages and communications you send</li>
                    <li>Age verification confirmation</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>2. How We Use Your Information</h3>
                  <p className="mb-2">We use collected information for the following purposes:</p>
                  <ul className="list-disc ml-6 space-y-1">
                    <li>To provide and maintain website functionality</li>
                    <li>To verify age compliance (18+ requirement)</li>
                    <li>To respond to your inquiries and communications</li>
                    <li>To improve user experience and website performance</li>
                    <li>To detect and prevent fraud or unauthorized access</li>
                    <li>To comply with legal obligations</li>
                    <li>To protect against harassment, abuse, or illegal activity</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>3. Cookies & Tracking Technologies</h3>
                  <p className="mb-2">
                    This website uses session cookies and similar technologies to:
                  </p>
                  <ul className="list-disc ml-6 space-y-1 mb-3">
                    <li>Remember age verification status during your browsing session</li>
                    <li>Improve website functionality and user experience</li>
                    <li>Analyze website traffic and usage patterns</li>
                  </ul>
                  <p>
                    You can control cookie settings through your browser preferences. Note that disabling cookies may affect 
                    website functionality.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>4. Third-Party Services</h3>
                  <p className="mb-2">
                    This website may integrate with third-party platforms:
                  </p>
                  <ul className="list-disc ml-6 space-y-1 mb-3">
                    <li><span className="font-semibold">WhatsApp:</span> For direct communication (subject to WhatsApp's privacy policy)</li>
                    <li><span className="font-semibold">Social Media:</span> Links to Instagram, X (Twitter), and Telegram (each governed by their respective privacy policies)</li>
                    <li><span className="font-semibold">Analytics:</span> We may use web analytics to understand site usage</li>
                  </ul>
                  <p className="text-sm italic">
                    These third-party services have their own privacy policies. We recommend reviewing them separately.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>5. Information Sharing & Disclosure</h3>
                  <p className="mb-2 font-semibold">We do NOT sell, rent, or trade your personal information.</p>
                  <p className="mb-2">Information may only be disclosed:</p>
                  <ul className="list-disc ml-6 space-y-1">
                    <li>When required by law or legal process</li>
                    <li>To protect our rights, property, or safety</li>
                    <li>To prevent fraud, abuse, or illegal activity</li>
                    <li>With your explicit consent</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>6. Data Security</h3>
                  <p className="mb-2">
                    We implement reasonable security measures to protect your information, including:
                  </p>
                  <ul className="list-disc ml-6 space-y-1 mb-3">
                    <li>Secure data transmission protocols</li>
                    <li>Limited access to personal information</li>
                    <li>Regular security assessments</li>
                  </ul>
                  <p>
                    However, no method of transmission over the internet is 100% secure. We cannot guarantee absolute security.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>7. Discretion & Confidentiality</h3>
                  <p className="mb-2">
                    <span className="font-semibold">Your privacy is paramount.</span> We understand the sensitive nature of adult content 
                    and maintain strict confidentiality regarding:
                  </p>
                  <ul className="list-disc ml-6 space-y-1">
                    <li>Your visit to this website</li>
                    <li>Communications and interactions</li>
                    <li>Personal information shared</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>8. Age Verification & Minors</h3>
                  <p className="mb-2">
                    This website is strictly for adults 18 years and older. We do NOT knowingly collect information from minors. 
                    If we discover that a minor has accessed this site, we will take immediate action to restrict access and 
                    delete any collected information.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>9. Your Rights & Choices</h3>
                  <p className="mb-2">You have the right to:</p>
                  <ul className="list-disc ml-6 space-y-1">
                    <li>Access information we hold about you</li>
                    <li>Request correction of inaccurate information</li>
                    <li>Request deletion of your information (subject to legal requirements)</li>
                    <li>Opt-out of communications</li>
                    <li>Withdraw consent where applicable</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>10. International Users</h3>
                  <p className="mb-2">
                    This website may be accessed from various countries. By using this site, you consent to the transfer 
                    and processing of information in accordance with this Privacy Policy and applicable laws.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>11. Data Retention</h3>
                  <p className="mb-2">
                    We retain information only as long as necessary for the purposes outlined in this policy or as required by law. 
                    Session data (such as age verification) is automatically deleted when you close your browser.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>12. Changes to Privacy Policy</h3>
                  <p className="mb-2">
                    We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page with 
                    an updated "Last Updated" date. Continued use of the website constitutes acceptance of the revised policy.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#EBBEDA'}}>13. Do Not Track (DNT)</h3>
                  <p className="mb-2">
                    Some browsers include a "Do Not Track" feature. This website does not currently respond to DNT signals, 
                    but we respect your privacy choices through browser settings and opt-out mechanisms.
                  </p>
                </div>

                <div className="mt-8 p-6 rounded-2xl border-2" style={{borderColor: '#EBBEDA', background: '#FFF5F7'}}>
                  <p className="font-bold mb-2">🔒 Your Privacy Matters</p>
                  <p className="text-sm">
                    We are committed to protecting your privacy and maintaining discretion. All interactions are confidential. 
                    If you have concerns about your privacy, please contact us immediately.
                  </p>
                </div>

                <div className="text-center mt-8">
                  <p className="font-bold mb-2">Contact for Privacy Questions:</p>
                  <a 
                    href="https://wa.me/447386375420"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block px-6 py-2 rounded-full font-semibold"
                    style={{background: '#EBBEDA', color: 'white'}}
                  >
                    Contact via WhatsApp
                  </a>
                  <p className="text-sm text-gray-500 mt-3">Email: privacy@izziefox.com (if applicable)</p>
                </div>
              </div>
            </div>

            <div className="sticky bottom-0 bg-white rounded-b-3xl border-t-2 p-6 text-center" style={{borderColor: '#EBBEDA'}}>
              <button 
                onClick={() => setShowPrivacy(false)}
                className="px-8 py-3 rounded-full font-bold text-white"
                style={{background: '#EBBEDA'}}
              >
                I Understand
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;